"use client";

import { c as _c } from "react/compiler-runtime";
import Script from "next/script";
import { useEffect, useState } from "react";
import { useMe } from "@/hooks/useMe";
import { useOrganization } from "@/hooks/useOrganization";
import { useTeamsContext } from "@/hooks/useTeamsContext";
import { clientEnv } from "@/lib/env.client";
export function ChameleonProvider() {
  const $ = _c(22);
  const {
    me,
    userId,
    isLoading: meLoading
  } = useMe();
  const {
    currentTeam,
    isLoading: teamsLoading
  } = useTeamsContext();
  const {
    currentOrganization,
    isLoading: organizationsLoading
  } = useOrganization();
  const [scriptReady, setScriptReady] = useState(false);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = clientEnv();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const isChameleonEnabled = t0.NEXT_PUBLIC_CHAMELEON_ENABLED === "true";
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setScriptReady(true);
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const onScriptReady = t1;
  let t2;
  if ($[2] !== currentOrganization?.attributes?.name || $[3] !== currentOrganization?.attributes?.salesforceId || $[4] !== currentTeam?.attributes?.salesforceId || $[5] !== me || $[6] !== meLoading || $[7] !== organizationsLoading || $[8] !== scriptReady || $[9] !== teamsLoading || $[10] !== userId) {
    t2 = () => {
      if (!isChameleonEnabled || !scriptReady) {
        return;
      }
      if (meLoading || teamsLoading || organizationsLoading || !me || !userId) {
        return;
      }
      if (window.chmln) {
        const {
          firstName,
          lastName,
          email,
          createdAt
        } = me.data.attributes;
        const displayName = firstName && lastName ? `${firstName} ${lastName}`.trim() : email;
        const teamSalesforceId = currentTeam?.attributes?.salesforceId;
        const orgSalesforceId = currentOrganization?.attributes?.salesforceId;
        const companyUid = teamSalesforceId || orgSalesforceId || undefined;
        window.chmln.identify(userId, {
          uid_hash: me.meta?.chameleonUserIdHash,
          email,
          name: displayName,
          created: createdAt,
          company: {
            uid: companyUid,
            name: currentOrganization?.attributes?.name
          }
        });
      }
    };
    $[2] = currentOrganization?.attributes?.name;
    $[3] = currentOrganization?.attributes?.salesforceId;
    $[4] = currentTeam?.attributes?.salesforceId;
    $[5] = me;
    $[6] = meLoading;
    $[7] = organizationsLoading;
    $[8] = scriptReady;
    $[9] = teamsLoading;
    $[10] = userId;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  let t3;
  if ($[12] !== currentOrganization || $[13] !== currentTeam || $[14] !== me || $[15] !== meLoading || $[16] !== organizationsLoading || $[17] !== scriptReady || $[18] !== teamsLoading || $[19] !== userId) {
    t3 = [me, userId, meLoading, teamsLoading, organizationsLoading, currentTeam, currentOrganization, scriptReady, isChameleonEnabled];
    $[12] = currentOrganization;
    $[13] = currentTeam;
    $[14] = me;
    $[15] = meLoading;
    $[16] = organizationsLoading;
    $[17] = scriptReady;
    $[18] = teamsLoading;
    $[19] = userId;
    $[20] = t3;
  } else {
    t3 = $[20];
  }
  useEffect(t2, t3);
  if (!isChameleonEnabled) {
    return null;
  }
  let t4;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Script id="dc-chameleon" strategy="lazyOnload" onReady={onScriptReady}>{"\n        !function(d,w){var t=\"STAHYbAM7upE8UdSPYOrXYER6V0DbhVXeaXfeoa6HHI8iP-1TYesZ-FORE4BrJPj0NTgzW\",c=\"chmln\",i=d.createElement(\"script\");if(w[c]||(w[c]={}),!w[c].root){w[c].accountToken=t,w[c].location=w.location.href.toString(),w[c].now=new Date,w[c].fastUrl='https://fast.chameleon.io/';var m=\"identify alias track clear set show on off custom help _data\".split(\" \");for(var s=0;s<m.length;s++){!function(){var t=w[c][m[s]+\"_a\"]=[];w[c][m[s]]=function(){t.push(arguments);};}();}i.src=w[c].fastUrl+\"messo/\"+t+\"/messo.min.js\",i.async=!0,d.head.appendChild(i);}}(document,window);\n      "}</Script>;
    $[21] = t4;
  } else {
    t4 = $[21];
  }
  return t4;
}